//-- Copyright (c) 2021 TMT Insights Group, LLC
import { createSlice } from '@reduxjs/toolkit';
import { LayoutState } from './slice_types';

const initialState: LayoutState = {
  isNavBarVisible: true,
  schema: {
    showDialog: false,
    errors: []
  }
};

const layoutSlice = createSlice({
  name: 'layout',
  initialState,
  reducers: {
    setIsNavBarVisible: (state, { payload }: { payload: boolean }) => {
      state.isNavBarVisible = payload;
    },
    setSchemaDialogErrors: (state, { payload }) => {
      state.schema.showDialog = true;
      state.schema.errors = payload;
    },
    clearSchemaDialogErrors: (state) => {
      state.schema.showDialog = false;
      state.schema.errors = [];
    }
  }
});

export default layoutSlice.reducer;

export const { setIsNavBarVisible, setSchemaDialogErrors, clearSchemaDialogErrors } = layoutSlice.actions;
